import * as React from 'react';

import './ECheckRowDesktop.scss';
import LocaleFormating from 'src/translation/localeFormating';
import RCheckbox from 'src/components/common/RCheckbox/RCheckbox';

interface IECheckRowProps {
  payment: any;
  onShowDetails: (e: any, payment: any) => void;
  onChangeCheckbox: (payment: any, handleChecked: any) => void;
}

interface IECheckRowState {
  isChecked: boolean;
}
class ECheckRow extends React.Component<IECheckRowProps, IECheckRowState> {
  constructor(props: any) {
    super(props);

    this.state = {
      isChecked: false
    };
  }

  public componentDidMount = () => {
    const { payment } = this.props;

    if (payment.disposition === 'VT') {
      this.setState({
        isChecked: true
      });
    }
  };

  private handleChecked = () => {
    if (!this.state.isChecked) {
      this.setState({
        isChecked: true
      });
    } else {
      this.setState({
        isChecked: false
      });
    }
  };

  public render() {
    return (
      <div className="row rp-echeck-row">
        <div className="col-3 rp-echeck-item">
          <a
            href="#"
            className="rp-echeck-content --tracking-number"
            onClick={e => this.props.onShowDetails(e, this.props.payment)}
          >
            {this.props.payment.paymentNumber}
          </a>
        </div>
        <div className="col-2 rp-echeck-item">
          <span className="rp-echeck-content">
            {LocaleFormating.formatDate(
              this.props.payment.paymentDateTime,
              'short'
            )}
          </span>
        </div>
        <div className="col-1 rp-echeck-item">
          <span className="rp-echeck-content">
            {this.props.payment.customerCode}
          </span>
        </div>
        <div className="col-2 rp-echeck-item">
          {this.props.payment.status === 'APPROVED' ? (
            <i className="rpds-check-circle" />
          ) : (
            <i className="rpds-error" />
          )}
          <span className="rp-echeck-content">{this.props.payment.status}</span>
        </div>
        <div className="col-1 rp-echeck-item">
          <span className="rp-echeck-content">
            {LocaleFormating.formatCurrency(this.props.payment.paymentAmount)}
          </span>
        </div>
        <div className="col-3 rp-echeck-item">
          <RCheckbox
            id={this.props.payment.paymentNumber}
            onChanged={() =>
              this.props.onChangeCheckbox(
                this.props.payment,
                this.handleChecked
              )
            }
            color={this.props.payment.taker ? 'gray' : 'green'}
            usesLabel={true}
            label={'VOID THIS PAYMENT'}
            type={'box'}
            checked={this.state.isChecked}
            disabled={this.props.payment.taker ? true : false}
          />
        </div>
      </div>
    );
  }
}

export default ECheckRow;
